import cookie from "react-cookie";

export const SHOW_TIPS = Symbol('SHOW_TIPS');
export const HIDE_TIPS = Symbol('HIDE_TIPS');

export function showTips() {
    cookie.save('ll_hide_tips', 'false');

    return {
        type: SHOW_TIPS
    };
}

export function hideTips() {
    cookie.save('ll_hide_tips', 'true',  { path: '/' });

    return {
        type: HIDE_TIPS
    };
}


